import moment from 'moment-timezone';
import React, {useState, useEffect} from 'react'

// Redux
import { useSelector, useDispatch } from 'react-redux'
import { getNoticeOptions, submitNoticeOptions } from '../../../../../store/actions/reviewsEmail'
import { userTokenUpdate, userLogout } from "../../../../../store/actions/user";
import { addRoute } from "../../../../../store/actions/route";

import GeneralLoader from '../../../../GeneralLoader';
import AdminNoticeEmailForm from './AdminNoticeEmailForm';

const AdminNoticeEmail = () => {
    const [formData, setFormData] = useState({});
    const dispatch       = useDispatch();
    const stateReviewsEmail = useSelector(state => state.reviewsEmail);

    useEffect(() => {
        (() => {
            // Add route for Admin Nav Active tracking
            dispatch(addRoute({
                type: '',
                route: '/admin/auto-notice-email'
            }))

            // Fetch data from API, then store into local component state for form
            dispatch(getNoticeOptions()).then((resp) => {
                if (resp.data.status === 403) {
                    dispatch(userLogout("admin"));
                    return;
                }

                // Set data and format dates to moment objects for date picker
                setFormData({ ...resp.data.notice_options });
            })
        })()
    }, [])

    const handleInputChange = (event) => {
		const { id, value } = event.target;

        setFormData((formData) => ({
            ...formData,
            [id]: value
        }))
    }

    const handleCheckboxChange = (event) => {
		const { id } = event.target;

        setFormData((formData) => ({
            ...formData,
            [id]: formData[id] == 0 ? 1 : 0
        }))
    }

    const handleDateChange = (value, id) => {
        setFormData((formData) => ({
            ...formData,
            [id]: value
        }))
    }

    // const handleSectorCheckboxChange = (event) => {
	// 	const { id } = event.target;

    //     setFormData((formData) => ({
    //         ...formData,
    //         sectors: {
    //             ...formData.sectors,
    //             [id]: formData.sectors[id] == 0 ? 1 : 0
    //         }
    //     }))
    // }

    // When form options are saved
    const handleFormSubmit = () => {
        dispatch(submitNoticeOptions(formData)).then((response) => {
            if (!!response.data.token) {
                dispatch(userTokenUpdate("admin", response.data.token));
            }
            if (response.data.status === 403) {
                dispatch(userLogout("admin"));
                return;
            }
        });
    }

    return (
		<React.Fragment>
            <div className="linked-title">
                <h1>Reviews - Notice Email</h1>
            </div>

            {/* Options Loading */}
            {stateReviewsEmail.noticeOptionsLoading 
                ? <GeneralLoader /> 
                : (
                    <React.Fragment>
                        <AdminNoticeEmailForm 
                            data={formData}
                            loading={stateReviewsEmail.noticeOptionsLoading}
                            errors={stateReviewsEmail.noticeOptionsError}
                            success={stateReviewsEmail.noticeOptionsSuccess}
                            handleInputChange={e => handleInputChange(e)}
                            handleDateChange={(date, id) => handleDateChange(date, id)}
                            handleCheckboxChange={e => handleCheckboxChange(e)}
                            // handleSectorCheckboxChange={e => handleSectorCheckboxChange(e)}
                            handleSubmit={() => handleFormSubmit()}
                        />
                    </React.Fragment>
                )
            }
        </React.Fragment>
    )
}

export default AdminNoticeEmail


// WEBPACK FOOTER //
// ./src/components/admin/reviews/reviews-email/notice-email/AdminNoticeEmail.js